import { useEffect, useRef, useState } from 'react';

// Detecta quais ids de uma lista apareceram pela primeira vez desde a
// última renderização, para animar a entrada de itens novos numa lista
// que atualiza por polling (sem isso, itens novos só "aparecem" sem aviso).
export default function useNewItemIds(ids) {
  const [newIds, setNewIds] = useState(() => new Set());
  const seenRef = useRef(null);
  const timeoutRef = useRef(null);
  const key = ids.join(',');

  useEffect(() => {
    const seen = seenRef.current;
    if (seen) {
      const novos = ids.filter(id => !seen.has(id));
      if (novos.length > 0) {
        setNewIds(prev => new Set([...prev, ...novos]));
        clearTimeout(timeoutRef.current);
        timeoutRef.current = setTimeout(() => {
          setNewIds(prev => {
            const next = new Set(prev);
            novos.forEach(id => next.delete(id));
            return next;
          });
        }, 1200);
      }
    }
    seenRef.current = new Set(ids);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key]);

  useEffect(() => () => clearTimeout(timeoutRef.current), []);

  return newIds;
}
